import axios from "axios";

const api = async (method, path, params) => axios[method](path, params);

const state = {
  item: null,
  options: [],
  items: [],
  loading: false,
  error: null,
};

const mutations = {
  set_item(state, data) {
    state.item = data;
  },
  set_items(state, data) {
    state.items = data;
  },
  set_options(state, data) {
    state.options = data;
  },
  set_loading(state, data) {
    state.loading = data;
  },
  set_error(state, data) {
    state.error = data;
  },
};

const actions = {
  async create({ commit, state }, { data, callback }) {
    try {
      commit("set_loading", true);
      commit("set_error", null);
      console.log("create:  data", data);
      const results = await api("post", `email-schedule`, data);

      console.log("create:  results", results);
      const emailSchedule = results.data.success.data;
      state.items.push(emailSchedule);
      commit("set_item", emailSchedule);
      callback && callback();
    } catch (err) {
      console.error("create:", err);
      commit("set_error", err);
    } finally {
      commit("set_loading", false);
    }
  },

  async fetchById({ commit, state }, id) {
    try {
      commit("set_loading", true);
      commit("set_error", null);
      const results = await api("get", `email-schedule/${id}`);
      const emailSchedule = results.data.success.data;
      const idx = state.items.findIndex((x) => x.id === id);
      state.items.splice(idx, 1, emailSchedule);
      commit("set_item", emailSchedule);
    } catch (err) {
      commit("set_error", err);
    } finally {
      commit("set_loading", false);
    }
  },

  async fetchAll({ commit }) {
    try {
      commit("set_loading", true);
      commit("set_error", null);
      const results = await api("get", `email-schedule`);
      console.log("results.data", results.data);
      const data = results.data.success.data;
      commit("set_items", data);
    } catch (err) {
      commit("set_error", err);
    } finally {
      commit("set_loading", false);
    }
  },

  async fetchStatements({ commit }) {
    try {
      commit("set_loading", true);
      commit("set_error", null);
      const results = await api("get", `email-schedule/options`);
      console.log("results.data", results.data);
      const data = results.data.success.data;
      console.log("store options:", data);
      commit("set_options", data);
    } catch (err) {
      commit("set_error", err);
    } finally {
      commit("set_loading", false);
    }
  },

  async triggerEmails({ commit }, id) {
    try {
      console.log("triggerEmails------------------:", id);
      commit("set_loading", true);
      commit("set_error", null);
      await api("get", `email-schedule/${id}/action-emails`);
    } catch (err) {
      commit("set_error", err);
    } finally {
      commit("set_loading", false);
    }
  },

  async update({ commit }, { data, callback }) {
    console.log("update:", data);
    try {
      commit("set_loading", true);
      commit("set_error", null);
      const results = await api("put", `email-schedule/${data.id}`, data);
      const emailSchedule = results.data.success.data;
      const idx = state.items.findIndex((x) => x.id === data.id);
      state.items.splice(idx, 1, emailSchedule);
      commit("set_item", emailSchedule);
      callback && callback();
    } catch (err) {
      commit("set_error", err);
    } finally {
      commit("set_loading", false);
    }
  },
  async delete({ commit, state }, { id, callback }) {
    try {
      commit("set_loading", true);
      commit("set_error", null);
      await api("delete", `email-schedule/${id}`);
      const idx = state.items.findIndex((x) => x.id === id);
      state.items.splice(idx, 1);
      commit("set_item", null);
      callback && callback();
    } catch (err) {
      commit("set_error", err);
    } finally {
      commit("set_loading", false);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
